import React from 'react';
import { FlexibleText } from '@mentimeter/slides-presentation-ui/text/flexible-text';
import { Box } from '@mentimeter/ragnar-ui/box';
import { MarkdownText } from '@mentimeter/slides-presentation-ui/text/markdown-text';
import type { HeadingStaticContent } from '@core-api/presentation/types/response';
import {
  usePresentationContext,
  usePresentationSlideContext,
} from '../../legacy-context/presentationContext';
import { getNinePointLayoutProperties } from '../../shared/utils/getNinePointLayoutProperties';
import { ContentSlideTitleSection } from '../../shared/components/ContentSlideTitleSection';
import { StaggerCss } from '../../shared/components/StaggerCss';
import { getLegacyLayout } from '../../utils/legacyContentSlideUtils/getLegacyLayout';

export function HeadingPresentation() {
  const {
    Utils: { fontOffset },
    useConfig,
  } = usePresentationContext();

  const slide = usePresentationSlideContext();
  const staticContent = slide.staticContent as HeadingStaticContent;
  const legacyLayout = getLegacyLayout(slide) ?? {
    type: 'default',
    font_size_offset: 0,
    alignment_x: 1,
    alignment_y: 1,
    size: '25%',
  };

  const { enableAnimations } = useConfig();

  const { textAlign, justifyContent, alignItems } =
    getNinePointLayoutProperties(legacyLayout);

  const breakpoints = [
    { count: 300, offset: -2 },
    { count: 200, offset: -1 },
  ];

  const fullText = staticContent.subheading
    ? staticContent.heading.length + staticContent.subheading.length
    : staticContent.heading.length;
  const width = 30;
  const height = Math.round(fullText / width);
  const offset =
    fontOffset({
      height,
      width,
      breakpoints,
    }) + (legacyLayout?.font_size_offset ?? 0);

  return (
    <Box
      width="100%"
      height="70%"
      alignItems={alignItems}
      justifyContent={justifyContent}
    >
      <ContentSlideTitleSection
        question={staticContent.heading}
        title_meta={staticContent.label}
        layout={legacyLayout}
        textAlign={textAlign}
        alignItems={alignItems}
        enableAnimations={true}
        lineHeight="none"
        mb="space4"
      />
      {staticContent.subheading && (
        <FlexibleText
          mb={0}
          textAlign={textAlign}
          fontOffset={offset}
          fontSize={5}
          color="text"
        >
          <StaggerCss index={2} enableAnimations={enableAnimations}>
            <MarkdownText
              source={staticContent.subheading}
              disableLineBreaks={false}
              allowBlankLines
              allowHyperlinks
            />
          </StaggerCss>
        </FlexibleText>
      )}
    </Box>
  );
}
